import { addToChainAfter, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { AddAccountApiParameter, updateAccount } from "@insite/client-framework/Services/AccountService";
import {
    AddAccount,
    AddAccountParameter,
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { AccountModel, CountryModel, StateModel } from "@insite/client-framework/Types/ApiModels";
import { thosAddAccount } from "@thos/Services/ThosAccountService";
import { ThosAddAccountModel } from "@thos/Services/ThosApiModels";

export interface ThosAddAccountParameter extends AddAccountParameter {
    firstName: string;
    lastName: string;
    companyName: string;
    streetAddress1: string;
    streetAddress2: string;
    city: string;
    postalCode: string;
    phoneNumber: string;
    country: string;
    state: string;
    accountInfo: ThosAddAccountModel;
}

addToChainAfter(chain, AddAccount, ThosPopulateApiParameter);

async function ThosPopulateApiParameter(props: any) {
    if (props.apiResult.successful) {
        props.apiResult = await thosAddAccount(props.parameter);
    }
}

addToChainAfter(chain, PopulateApiParameter, AddAcccountModelProperties);

function AddAcccountModelProperties(props: any) {
    const accountModel = props.apiParameter.account as AccountModel;
    const accountInfo = props.parameter.accountInfo as ThosAddAccountModel;

    const properties = {
        registrationAccountNumber: accountInfo.accountNumber,
    };

    accountModel.properties = properties;
    accountModel.firstName = accountInfo.firstName;
    accountModel.lastName = accountInfo.lastName;

    props.apiParameter.account = accountModel;
}
